import React from 'react';
import { Section } from '../ui/Section';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: "I haven't slept through the night in 4 years. The 'Thermal Drop' technique worked on the first night. I actually woke up before my alarm feeling rested.",
    author: 'Sarah J.',
    role: 'Corporate Attorney',
    initials: 'SJ'
  }, {
    quote: "Skeptical at first because I've tried everything (melatonin, CBD, meditation). This is just pure biology. It works because it's how our bodies are designed.",
    author: 'Michael R.',
    role: 'Software Architect',
    initials: 'MR'
  }, {
    quote: "The 'Panic Button' trick for 3AM wakeups is worth the $37 alone. I used to lie awake for hours. Now I'm back out in 5 minutes.",
    author: 'David K.',
    role: 'Investment Banker',
    initials: 'DK'
  }];
  return <Section background="navy" data-id="element-114">
      <div className="text-center mb-12" data-id="element-115">
        <h2 className="text-3xl font-serif font-bold text-brand-cream mb-3" data-id="element-116">
          From "Wired but Tired" to Restored
        </h2>
        <p className="text-brand-muted" data-id="element-117">
          Join hundreds of high-performers reclaiming their rest.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-118">
        {testimonials.map((t, idx) => <div key={idx} className="bg-brand-night border border-brand-border rounded-xl p-6" data-id="element-119">
            <div className="flex gap-1 mb-4" data-id="element-120">
              {[1, 2, 3, 4, 5].map(s => <Star key={s} className="h-4 w-4 fill-brand-amber text-brand-amber" data-id="element-121" />)}
            </div>
            <p className="text-brand-parchment mb-6 italic leading-relaxed text-sm" data-id="element-122">
              "{t.quote}"
            </p>
            <div className="flex items-center gap-3" data-id="element-123">
              <div className="w-9 h-9 rounded-full bg-brand-amber/10 border border-brand-amber/30 text-brand-amber flex items-center justify-center font-bold text-xs" data-id="element-124">
                {t.initials}
              </div>
              <div data-id="element-125">
                <p className="font-bold text-brand-cream text-sm" data-id="element-126">{t.author}</p>
                <p className="text-xs text-brand-muted" data-id="element-127">{t.role}</p>
              </div>
            </div>
          </div>)}
      </div>
    </Section>;
}